var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.76,
    height: 25.258,
    viewBox: "0 0 29.76 25.258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 12.875,
    height: 12.848,
    transform: "translate(0 0)",
    fill: "#ed9c2e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(0 -0.226)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(0 0.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M14.885,25.254q-6.824,0-13.648,0a1.575,1.575,0,0,1-.881-.127.674.674,0,0,1-.35-.688.661.661,0,0,1,.549-.632A2.329,2.329,0,0,1,.8,23.785c1.461-.117,1.461-.117,1.461-1.609q0-10.4,0-20.8C2.261.154,2.413,0,3.622,0H26.149c1.211,0,1.365.154,1.365,1.371,0,7.18.013,14.36-.019,21.54,0,.736.187,1,.9.874a2.869,2.869,0,0,1,.328,0c.548-.034,1.048.073,1.034.737s-.525.737-1.063.736q-6.906-.006-13.812,0M11.949,15.095c-.3.324-.468.5-.628.67-.288.316-.6.656-1.022.239-.39-.385-.053-.7.2-.982.807-.9,1.611-1.794,2.434-2.674a1.017,1.017,0,0,0,.33-.859,1.256,1.256,0,0,1,1.161-1.419,1.282,1.282,0,0,1,.178,2.557,2.018,2.018,0,0,0-1.532,1.719c-.007,1.562.015,3.125-.013,4.686-.009.482.09.657.622.654,3.919-.025,5.838-.025,9.757,0,.546,0,.616-.2.615-.67-.014-5.618-.015-9.236,0-14.855,0-.51-.093-.707-.663-.706-7.016.02-10.032.016-17.047.005-.435,0-.627.072-.626.574.017,5.7.016,9.4,0,15.1,0,.45.159.547.572.544,2.384-.016,2.769-.016,5.153,0,.4,0,.517-.124.511-.515-.02-1.284-.007-2.569-.007-4.072M4.664,22.447c0-.3-.016-.6,0-.9.023-.341-.152-.406-.446-.41-.321,0-.518.045-.5.441.027.6.02,1.2,0,1.8-.01.336.145.41.446.413.326,0,.527-.057.5-.443-.023-.3,0-.6,0-.9m4.754.031c0-.3-.019-.6,0-.9.032-.4-.186-.441-.5-.442-.3,0-.45.071-.438.41.021.6.014,1.2,0,1.8-.006.294.061.462.4.443.289-.016.559.008.532-.411-.019-.3,0-.6,0-.9m4.746-.035c0-.273-.021-.548,0-.819.04-.424-.18-.481-.539-.494-.448-.017-.385.26-.384.528,0,.546.009,1.093,0,1.639-.007.307.017.5.426.5s.525-.166.5-.537c-.019-.272,0-.546,0-.819m2.368-.005c0-.246,0-.492,0-.738,0-.3.068-.591-.425-.574-.407.014-.518.161-.5.538.024.518.013,1.038,0,1.558-.006.324-.005.571.455.578.442.006.492-.2.47-.542-.018-.272,0-.546,0-.82m4.757.06c0-.3-.02-.6.005-.9.03-.362-.114-.469-.466-.466s-.489.113-.475.473c.022.6.016,1.2,0,1.8-.007.358.206.377.478.382s.481-.034.458-.39c-.02-.3,0-.6,0-.9m3.823-.146c0,.356.011.711,0,1.066s.22.364.483.37c.288.007.467-.048.458-.4-.018-.628-.016-1.258,0-1.886.01-.377-.227-.361-.485-.368-.283-.007-.481.043-.456.4.019.272,0,.546,0,.82m-18.98.073c0,.3.016.6,0,.9-.025.361.122.47.477.466.337,0,.42-.142.413-.442-.013-.6-.019-1.206,0-1.808.012-.335-.126-.42-.434-.411-.277.008-.487.021-.459.387.023.3,0,.6,0,.9m5.64.082c0-.326-.019-.653.005-.976.026-.346-.143-.408-.438-.4-.265.011-.479.008-.466.378.021.623.014,1.248,0,1.871-.006.326.148.409.448.408s.474-.042.452-.39c-.018-.3,0-.6,0-.895M18,22.384c0,.325.012.652,0,.976-.014.3.076.451.41.431.26-.016.493,0,.487-.364q-.014-.976,0-1.953c.006-.391-.266-.319-.5-.335-.257-.018-.413.049-.4.35s0,.6,0,.895m5.638.121c0-.329-.018-.659,0-.986.026-.369-.187-.375-.461-.385-.311-.011-.442.083-.431.414.021.6.015,1.205,0,1.808-.006.3.083.434.416.44.36.006.5-.113.473-.47-.019-.273,0-.548,0-.822",
    transform: "translate(0)",
    fill: "#003E7F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(13.561 1.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M4.181,0A18.646,18.646,0,0,0,.227,2.246c-.395.337-.23.919.162,1.314,1.194,1.2,2.378,2.415,3.6,3.589.671.646,1.307.489,1.755-.292.56-.976,1.081-1.976,1.608-2.971a.965.965,0,0,0-.005-1.165c-.8-.851-1.628-1.669-2.47-2.475C4.731.108,4.466.1,4.181,0m.144,4.906a6.581,6.581,0,0,0-.94-1.177c-.914-.716-.257-.936.314-1.239a.578.578,0,0,1,.7.083c.927.652.9,1.351-.073,2.333",
    transform: "translate(5.33 0)",
    fill: "#ed9c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M25.077,28.295a1.052,1.052,0,0,0,.587.966.86.86,0,0,0,1.048-.131c.869-.832,1.73-1.673,2.552-2.55a.913.913,0,0,0,.005-1.244.855.855,0,0,0-1.208-.25A17.159,17.159,0,0,0,25.2,27.937a.978.978,0,0,0-.122.357",
    transform: "translate(-22.329 -19.27)",
    fill: "#ed9c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M35.936,17.445c.889-.332,2.062-.728,3.2-1.214a.842.842,0,0,0,.392-1.164.876.876,0,0,0-1.075-.617c-1.145.354-2.281.75-3.387,1.211a.868.868,0,0,0-.4,1.173c.158.429.5.643,1.269.611",
    transform: "translate(-34.589 -11.14)",
    fill: "#ed9c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M14.509,38.182c-.018.746.2,1.129.693,1.27a.887.887,0,0,0,1.145-.482c.433-1.078.825-2.175,1.168-3.285a.893.893,0,0,0-.581-1.1.833.833,0,0,0-1.176.343c-.5,1.129-.892,2.3-1.249,3.252",
    transform: "translate(-7.975 -26.654)",
    fill: "#ed9c2e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndoor);
export default __webpack_public_path__ + "static/media/icon-indoor.532067fba6bf00c5c328202c80c8be54.svg";
export { ForwardRef as ReactComponent };